import { applyBetsReportingQueries, QueryBuilder } from "./Helpers";
export const BetsReportingConnection = {
    getSettledBets(q) {
        return applyBetsReportingQueries(QueryBuilder.getSettledBets(q));
    }
};
//# sourceMappingURL=BetsReportingConnection.js.map